<template>
    <div class="navigation vertical-container vertical-container--in-secondary-side">
        <div class="vertical-container__header">

            <div v-if="!units.length">
                <strong>Projekt neobsahuje žádné jednotky.</strong>
            </div>

            <div v-if="units.length">
                <div class="navigation-title">Jednotky</div>
                <form-input v-model="search" name="search" placeholder="Vyhledat" class="m--t-1"/>
            </div>
        </div>

        <div class="vertical-container__content">
            <ul class="navigation-list">
                <li :key="unit.id" class="navigation-list__item" v-for="unit in filteredUnits">
                    <router-link :to="{ name: 'project-unit-detail', params: {unitId: unit.id}}"
                                 class="navigation-list__link">
                        {{ unit.designation }}
                    </router-link>
                </li>
            </ul>
        </div>

        <div class="vertical-container__footer">
            <div class="button-fix">
                <custom-button @click="create" primary>Vytvořit jednotku</custom-button>
                <custom-button primaryadd @click="copy">
                    <span icon="clone"></span>
                    Duplikovat jednotku
                </custom-button>
            </div>
        </div>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CreateUnitDialog from '@/modules/ProjectModule/modules/UnitModule/components/Unit/CreateUnitDialog';
import CopyUnitDialog from '@/modules/ProjectModule/modules/UnitModule/components/Unit/CopyUnitDialog';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'UnitNav',
    components: {CustomButton, FormInput},
    computed:   {
        unitId() {
            return this.$store.getters['projects/project/units/unit/unitId']
        },
        units() {
            return this.$store.getters['projects/project/units/units'];
        },
        filteredUnits() {
            if (this.search.length === 0) {
                return this.units;
            }
            return this.units.filter(({designation}) => {
                return designation.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            })
        }
    },
    data() {
        return {
            search: '',
        }
    },
    methods:    {
        create() {
            this.$modal.show(CreateUnitDialog, {}, defaultModalParameters());
        },
        copy() {
            this.$modal.show(CopyUnitDialog, {}, defaultModalParameters());
        },
        change() {

        }
    }
}
</script>
